<template>
  <div class="catalog-aside-menu">
    <a v-for="item in result.items" :href="item.link" class="catalog-aside-menu__item">
      <span
        class="catalog-aside-menu__text"
        :class="{ 'catalog-aside-menu__text_active': item.current }"
      >
        {{ item.text }}
      </span>
      <span class="catalog-aside-menu__count">{{ item.count }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'CatalogAsideMenu',
  props: {
    result: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-aside-menu {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 0 14px;
  color: var(--text-colour-primary);
  @include point-lg {
    padding: 32px 32px 0;
  }
  &__item {
    padding-bottom: 16px;
    border-bottom: 1px solid #dfdfdf;
    text-transform: uppercase;
    font-weight: 500;
    font-size: rem(16);
    line-height: 115%;
    letter-spacing: 0.08em;
    margin-top: 16px;
    @include point-lg {
      &:first-child {
        margin-top: 0;
      }
    }
  }
  &__text {
    &_active {
      color: var(--text-colour-secondary);
    }
  }
  &__count {
    color: #757575;
  }
}
</style>
